import { useEffect } from "react";

const SITE_URL = "https://humanity59.com";
const SITE_NAME = "Humanity59";
const DEFAULT_IMAGE =
  "https://readdy.ai/api/search-image?query=Warm%20editorial%20photograph%20of%20diverse%20volunteers%20in%20red%20vests%20distributing%20food%20packages%20to%20people%20in%20need%20inside%20a%20bright%20community%20hall%2C%20soft%20natural%20window%20light%2C%20hopeful%20and%20generous%20atmosphere%2C%20premium%20humanitarian%20campaign%20photography%2C%20clean%20composition%2C%20high%20detail&width=1600&height=900&seq=humanity59-hero&orientation=landscape";

interface SeoProps {
  title: string;
  description: string;
  keywords?: string;
  path?: string;
  ogType?: string;
  ogImage?: string;
  jsonLd?: object | object[];
  noindex?: boolean;
}

function upsertMeta(attr: "name" | "property", key: string, content: string) {
  let el = document.head.querySelector<HTMLMetaElement>(
    `meta[${attr}="${key}"]`
  );
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

function upsertCanonical(href: string) {
  let el = document.head.querySelector<HTMLLinkElement>(
    'link[rel="canonical"]'
  );
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", "canonical");
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
}

function upsertJsonLd(data: object | object[] | undefined) {
  const id = "seo-jsonld";
  let el = document.getElementById(id) as HTMLScriptElement | null;
  if (!data) {
    if (el) el.remove();
    return;
  }
  if (!el) {
    el = document.createElement("script");
    el.type = "application/ld+json";
    el.id = id;
    document.head.appendChild(el);
  }
  el.textContent = JSON.stringify(data);
}

export default function Seo({
  title,
  description,
  keywords,
  path = "/",
  ogType = "website",
  ogImage = DEFAULT_IMAGE,
  jsonLd,
  noindex = false,
}: SeoProps) {
  useEffect(() => {
    document.title = title;

    upsertMeta("name", "description", description);
    if (keywords) {
      upsertMeta("name", "keywords", keywords);
    }

    if (noindex) {
      upsertMeta("name", "robots", "noindex, nofollow");
    } else {
      const robots = document.head.querySelector<HTMLMetaElement>(
        'meta[name="robots"]'
      );
      if (robots) robots.remove();
    }

    const url = `${SITE_URL}${path}`;
    upsertCanonical(url);

    upsertMeta("property", "og:title", title);
    upsertMeta("property", "og:description", description);
    upsertMeta("property", "og:url", url);
    upsertMeta("property", "og:type", ogType);
    upsertMeta("property", "og:image", ogImage);
    upsertMeta("property", "og:site_name", SITE_NAME);
    upsertMeta("property", "og:locale", "fr_FR");

    upsertMeta("name", "twitter:title", title);
    upsertMeta("name", "twitter:description", description);
    upsertMeta("name", "twitter:image", ogImage);

    upsertJsonLd(jsonLd);

    return () => {
      if (noindex === false) {
        const robots = document.head.querySelector<HTMLMetaElement>(
          'meta[name="robots"]'
        );
        if (robots) robots.remove();
      }
    };
  }, [title, description, keywords, path, ogType, ogImage, jsonLd, noindex]);

  return null;
}